import { UnicodeEntity } from '@mews/enums';
import { Link, LinkProps, Typography } from '@optimus-web/core';

export interface MoreItemsLinkProps extends Pick<LinkProps, 'onClick'> {
    count: number;
}

export const MoreItemsLink = ({ count, onClick }: MoreItemsLinkProps) => (
    <Typography textStyle="bodyLargeStrong" as="div">
        <Link onClick={onClick} inherit standalone>
            {UnicodeEntity.PlusSign}
            {count}
        </Link>
    </Typography>
);
